import { CompositeLayer } from '@deck.gl/core';
import { PathStyleExtension } from '@deck.gl/extensions';
import { PathLayer } from '@deck.gl/layers';

class TrailingPathLayer extends CompositeLayer {
  renderLayers() {
    const { data, getPath } = this.props;

    const lineBorderLayer = new PathLayer(
      this.getSubLayerProps({
        id: 'trailing-path-layer-border',
        data,
        pickable: false,
        widthMaxPixels: 7,
        getColor: () => [135, 204, 234, 255],
        getWidth: () => 7,
        capRounded: true,
        jointRounded: true,
        getPath,
      }),
    );
    const lineFillLayer = new PathLayer(
      this.getSubLayerProps({
        id: 'trailing-path-layer-fill',
        data,
        pickable: false,
        widthMaxPixels: 2,
        getColor: () => [45, 45, 45, 255],
        getWidth: () => 2,
        capRounded: true,
        getPath,
      }),
    );
    const lineDashLayer = new PathLayer(
      this.getSubLayerProps({
        id: 'trailing-path-layer-dash',
        data,
        pickable: false,
        widthMaxPixels: 2,
        getColor: () => [255, 255, 255, 255],
        getWidth: () => 2,
        getPath,

        // props added by PathStyleExtension
        getDashArray: [4, 4],
        extensions: [new PathStyleExtension({ highPrecisionDash: true })],
      }),
    );

    // ESRI friendly order
    return [lineDashLayer, lineFillLayer, lineBorderLayer];
  }
}

TrailingPathLayer.layerName = 'TrailingPathLayer';
TrailingPathLayer.defaultProps = { visible: true, data: [] };

/**
 * This layer is the same as TrailingPathLayer, but the order of the layers is
 * reversed. This is used by the DeckOverlay to reverse layer order for map
 * providers that have different ordering conventions (like GMaps).
 */
export class TrailingPathLayerReversed extends TrailingPathLayer {
  renderLayers() {
    const layers = super.renderLayers();
    return layers.reverse();
  }
}

TrailingPathLayerReversed.layerName = 'TrailingPathLayerReversed';
TrailingPathLayerReversed.defaultProps = { visible: true, data: [] };

export default TrailingPathLayer;
